import styled, { css } from 'styled-components';

import { DynamicIconProps } from './interface-icon';

export const IconCircle = styled.div<
  DynamicIconProps & {
    height?: string;
    width?: string;
    marginLeft?: string;
    backgroundColor?: string;
  }
>(
  ({
    backgroundColor,
    width = '6px',
    height = '6px',
    marginLeft = '10px',
  }: DynamicIconProps & {
    height?: string;
    width?: string;
    marginLeft?: string;
    backgroundColor?: string;
  }) => {
    return css`
      display: flex;
      align-items: center;
      margin-left: ${marginLeft};

      &:before {
        content: '';
        width: ${width};
        height: ${height};
        border-radius: 50%;
        background-color: ${backgroundColor};
      }
    `;
  },
);
